import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { LifeStyle } from '../../PetSuggestion/Step2/LifeStyle';
// import Breed from '../../PetSuggestion/Step2/Breed';
import { DogsProfile } from '../../PetSuggestion/Step1/DogsProfile';
// import { FeedPercentage } from '../../PetSuggestion/Step3/FeedPercentage';
import { WeightSlider } from '../../PetSuggestion/Step2/WeightSlider';
import ButtonLoader from '../../common/ButtonLoader';
import StatusMessage from '../../common/StatusMessage';
import { DogsAgeType } from '../../../services/models';
import { StatusType } from '../../../types';
import { isBrowser } from '../../../utils';
import loadable from '@loadable/component';

const DogsName = loadable(() =>
  import('components/PetSuggestion/Step-1/DogName'),
);
const LifeStage = loadable(() =>
  import('components/PetSuggestion/Step-1/Lifestage'),
);
const Weight = loadable(() => import('components/PetSuggestion/Step-2/Weight'));
const BodyType = loadable(() =>
  import('components/PetSuggestion/Step-2/BodyType'),
);
const Activity = loadable(() =>
  import('components/PetSuggestion/Step-3/Activity'),
);
const Breed = loadable(() => 
  import('components/PetSuggestion/Step-4/Breed')
);

const FeedPercentage = loadable(() =>
  import('components/PetSuggestion/Step-3/FoodPercent/FeedPercentage'),
);

interface Props {
  initialValues: { [key: string]: any };
  submitButtonText?: string;
  submitStatusText?: string;
  onSubmit?: Function;
}

export const ManagePet: React.FC<Props> = props => {
  const [isSubmitting, setSubmitStatus] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const [serverErrors, setError] = useState([]);

  // const initialAgeData =
  //   props.submitButtonText === 'Add Furbaby'
  //     ? {
  //         type: DogsAgeType.LIFE_STAGE,
  //         value: 'puppy',
  //       }
  //     : props.initialValues.birth_date
  //     ? {
  //         type: DogsAgeType.BIRTH_DATE,
  //         value:
  //           typeof props.initialValues.birth_date !== 'string'
  //             ? props.initialValues.birth_date
  //             : new Date(props.initialValues.birth_date),
  //       }
  //     : { type: DogsAgeType.LIFE_STAGE, value: props.initialValues.age };
  // const [ageData, setAgeData] = useState(initialAgeData);

  useEffect(() => {
    isBrowser() &&
      window.scrollTo({
        top: 0,
        left: 100,
      });
  }, []);

  const setSuccessState = () => {
    setError([]);
    setSubmitStatus(false);
    setShowStatus(true);
    setTimeout(() => setShowStatus(false), 3000);
  };

  const setFailureState = e => {
    setSubmitStatus(false);
    setError(e);
    isBrowser() &&
      window.scrollTo({
        top: 100,
        left: 100,
        behavior: 'smooth',
      });
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    let payload = {...values}
    
    if (!payload['breed']) {
      delete payload['breed']
    }
    setSubmitStatus(true);
    props.onSubmit(
      payload,
      // ageData,
      setSuccessState,
      setFailureState,
      resetForm,
    );
  };

  const validationSchema = Yup.object({
    // dogsName: Yup.string()
    //   .required('Required')
    //   .matches(/^[-&' 0-9a-zA-Z]+$/, 'Invalid characters'),
    // age: Yup.string().required('Required'),
    // weight: Yup.string().required('Required'),
    // lifeStyle: Yup.string().required('Required'),
    // breed: Yup.string(),

    activity: Yup.string().required(),
    bodyType: Yup.string().required(),
    dogsName: Yup.string()
      .max(20)
      .required()
      .matches(/^[-&' 0-9a-zA-Z]+$/, 'Invalid characters')
      .label("Dog's name"),
    weight: Yup.string()
      .required()
      .label('Weight'),
    lifestage: Yup.string().required(),
  });
  const isValidData = (data = {}) => {    
    let newData = {...data}
    delete newData['breed']
    const val = Object.values(newData).every(value => value);
    return val;
  };
  return (
    <>
      <Formik
        initialValues={{
          // ...props.initialValues,
          activity: props?.initialValues?.activity_level,
          bodyType: props?.initialValues?.body_type,
          dogsName: props?.initialValues?.name,
          lifestage: props?.initialValues?.age,
          weight: props.initialValues.weight ? Math.round(parseFloat(props.initialValues.weight) * 10) / 10 : '',
          feedPercentage: props?.initialValues?.food_percent,
          breed: props?.initialValues?.breed || ''

        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ handleSubmit, handleChange, values, touched, errors }) => (
          <Form>
            {(serverErrors || []).length !== 0 && (
              <StatusMessage message={serverErrors} type={StatusType.error} />
            )}
            <div className="su-contents">
              <div className="main-cn">
                <div className="su-sections">

                  <div className="su-item-margin spacer">
                    <LifeStage
                      values={values}
                      handleChange={handleChange}
                      errors={errors}
                      touched={touched}
                    />
                  </div>

                  <div className="su-item-margin spacer">
                    <BodyType
                      values={values}
                      handleChange={handleChange}
                      errors={errors}
                      touched={touched}
                    />
                  </div>

                  <div className="su-item-margin spacer">
                    <Activity
                      values={values}
                      handleChange={handleChange}
                      errors={errors}
                      touched={touched}
                    />
                  </div>
                  <div className="su-item-margin spacer">
                    <Breed/>
                  </div>
                  <div className="su-item-margin spacer">
                    <DogsName
                      values={values}
                      handleChange={handleChange}
                      errors={errors}
                      touched={touched}
                    />
                  </div>
                  <div className="su-item-margin spacer">
                    <Weight
                      values={values}
                      handleChange={handleChange}
                      errors={errors}
                      touched={touched}
                    />
                  </div>
                  <div className="align-col-cen spacer">
                    <FeedPercentage
                      values={values}
                      handleChange={handleChange}
                      errors={errors}
                      touched={touched}
                    />
                  </div>
                  {/* <div className="su-item-margin">
                    <DogsProfile
                      values={values}
                      handleChange={handleChange}
                      errors={errors}
                      touched={touched}
                      ageData={ageData}
                      setAgeData={setAgeData}
                      isMultipleDog={true}
                    />
                  </div>
                  <div className="su-item-margin">
                    <div className="wt-lt-wrapper mgn-top-20">
                      <div className="wt-lt-item mgn-bot-40">
                        <div className="sub-hdr mgn-bot-10">Weight</div>
                        <WeightSlider name="weight" />
                      </div>
                    </div>
                  </div>
                  <div className="su-item-margin">
                    <div className="wt-lt-wrapper mgn-top-100">
                      <div className="wt-lt-item mgn-bot-40">
                        <div className="sub-hdr">Lifestyle</div>
                        <div className="lifestyle-slider-wrapper">
                          <LifeStyle name="lifeStyle" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="su-item-margin">
                    <div className="wt-lt-wrapper mgn-top-100">
                      <div className="wt-lt-item mgn-bot-40">
                        <div className="sub-hdr">Breed</div>
                        <Breed name="breed" />
                      </div>
                    </div>
                  </div>
                  <div className="su-item-margin">
                    <div className="wt-lt-wrapper mgn-top-100">
                      <div className="wt-lt-item">
                        <div className="sub-hdr mgn-bot-30">
                          Will your dog only eat Feed my Furbaby food?
                        </div>
                        <div className="content">
                          <div>
                            <FeedPercentage />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}

                  {showStatus && (
                    <div className="mgn-top-20 text-center text-primary txt-bold">
                      {props.submitStatusText}
                    </div>
                  )}

                  <div className="su-btn text-center mgn-top-100">
                    {' '}
                    <ButtonLoader
                      className="btn-def"
                      type="submit"
                      text={props.submitButtonText}
                      loading={isSubmitting}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
